import api from './axiosInstance';

function userId() {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.parent_id ?? user?.id;
  } catch { return null; }
}

export const getFarmsApi = ({ years, cropStatus }) =>
  api.get('/user/farms', {
    params: { years, cropStatus },
    headers: { user_id: userId() },
  });

export const addFarmApi = (data) => api.post('/user/add-farm', data, { headers: { user_id: userId() } });
export const updateFarmApi = (data) => api.post('/user/update-farm', data, { headers: { user_id: userId() } });
export const deleteFarmApi = (id) => api.delete('/delete-farm', { params: { id } });
export const updateFarmImageApi = (formData) => api.post('/update-farm-image', formData);
export const getRecentCropsApi = (userId) => api.get(`/recent-crop/${userId}`);
export const getBarNotificationApi = (userId) => api.get('/bar-notification', { params: { user_id: userId } });

export const getDashboardCountApi = ({ years }) =>
  api.get('/get-dashboard-count', { params: { years } });
